
import { Vue, Component } from 'vue-property-decorator'
import Option from '@/types/option'
import OptionEditDetailsTab from '@/views/option/tabs/edit/OptionEditDetailsTab.vue'
import OptionEditSubelementsTab from '@/views/option/tabs/edit/OptionEditSubelementsTab.vue'
import OptionEditEnabledIfTab from '@/views/option/tabs/edit/OptionEditEnabledIfTab.vue'
import OptionEditDisabledIfTab from '@/views/option/tabs/edit/OptionEditDisabledIfTab.vue'
import OptionEditSelectedIfTab from '@/views/option/tabs/edit/OptionEditSelectedIfTab.vue'
import ls from '@/ls'

@Component({
  components: { OptionEditSelectedIfTab, OptionEditDisabledIfTab, OptionEditEnabledIfTab, OptionEditSubelementsTab, OptionEditDetailsTab }
})

export default class OptionCreate extends Vue {
  settings = {
    routeNames: { list: 'options', show: 'optionShow', edit: 'optionEdit' },
    routeParamKey: 'optionId',
    functionNames: { setCurrent: 'setCurrentOption', clearCurrent: 'clearCurrentOption', save: 'saveOption' },
    getterNames: { current: 'currentOption', loading: 'loadingOption' }
  }

  currentTab:string = ls.get('optionEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('optionEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Option {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
